export default "__VITE_ASSET__CMaiKhGi__"